/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Fee Types
 */
export enum FeeType {
    MealPeriodViolation = 'Meal Period Violation',
    LatePayDamagesPerDayLT25 = 'Up to 25 Days (Per Day)',
    LatePayDamagesMaximum = 'Maximum',
    LatePayDamagesOnNonPaymentNotice = 'On Non-Nayment Notice',
    LatePayDamagesPerDayAfterNonPaymentNoticeGTE25 = 'Each Day After Non-Payment Notice ≧ 25 days',
}
